import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/30/thumb-landscape.jpg"

const Post30 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">Christian Louboutin／トリルビースモール／20 x15 x8cm</span>  
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>クリスチャン・ルブタンは1991年に自分のブティックをオープン。幼い頃ナイトクラブに出入りする環境があり、そこで興味を持ったのが靴でした。今では世界中の女性を虜にするクリスチャン・ルブタンのシューズといえば、「レッドソール（深紅の靴底）」が特徴ですよね♡実はバッグにも深紅が使われているのをご存知でしたか？今回は人気のクリスチャン・ルブタンのバッグ10選をご紹介します！</p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>パロマ</h2>
          <p>キャバレーで踊るショーガールの脚にインスパイアされたもの。ヌーディーカラーの細身のハンドルがポイント♡</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/1.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/2.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Christian Louboutin／パロマ・スモール／20 x21 x10cm</span>  
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/3.jpg" alt="" />
            <span className="text-center">Christian Louboutin／パロマ・ミディアム／30 x26 x12cm</span>  
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/4.jpg" alt="" />
              <span className="text-center">Christian Louboutin／パロマ・ミディアム／30 x27 x14cm</span>  
          </figure>
        </div>        
        <div className="text-max-width">
          <h2>ルビポッシュ</h2>
          <p>シンプルフォルムに全面にあしらわれたスタッズ。ルブタンらしさが溢れ出す洗練されたクラッチバッグです♡</p>          
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/5.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/6.jpg" alt="" />
              <span className="text-center">23x14x5cm</span>
          </figure>
        </div>
        <span className="text-center">Christian Louboutin／パロマクラッチ／23 x13 x5cm</span>  
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/7.jpg" alt="" />
            <span className="text-center">Christian Louboutin／ルビポッシュ／29 x19 x1cm</span>  
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/8.jpg" alt="" />
              <span className="text-center">Christian Louboutin／ルビポッシュ／31 x19 x2cm</span>  
          </figure>
        </div>        
        <div className="text-max-width">
          <h2>ボタニカル</h2>
          <p>使いやすいセパレート型なので小さいながらも収納力あり！視線を独り占めできるアクセントバッグです♪</p>
        </div>
        <div className="img-two-cloumn">
        <figure className="img-small">
              <StaticImage src="../../images/posts/30/9.jpg" alt="" />
            </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/10.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Christian Louboutin／トリックトラック／19 x30 x1cm</span>  
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/11.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/12.jpg" alt="" />
          </figure>
        </div>    
        <span className="text-center">Christian Louboutin／トリルビ／20 x14 x8cm</span>              
        <div className="text-max-width">
          <h2>スパイクスタッズ バックパック</h2>
          <p>大きめで収納力抜群！ハードな中にエレガントさを感じる一品です♡</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/13.jpg" alt="" />
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/14.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Christian Louboutin／エクスプローラファンクバックパック／28 x39 x15cm</span>       
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/15.jpg" alt="" />
            <span className="text-center">Christian Louboutin／エクスプローラファンクバックパック／28 x38 x16cm</span>       
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/16.jpg" alt="" />
              <span className="text-center">Christian Louboutin／ラッキーエル／20 x23 x13cm</span>       
          </figure>
        </div>            
        <div className="text-max-width">
          <h2>スウィートチャリティー</h2>
          <p>シックなメタルリボンがポイント♡ちょっとしたお出かけからパーティーまで華やかにしてくれます♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/17.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/18.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Christian Louboutin／スウィートチャリティー／24 x17 x7cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/19.jpg" alt="" />
            <span className="text-center">Christian Louboutin／スウィートチャリティー／14 x10 x5cm</span>   
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/20.jpg" alt="" />
              <span className="text-center">Christian Louboutin／スウィートチャリティー／14 x9 x4cm</span>   
          </figure>
        </div>        
        <Link to="https://laxus.co/app/pc/bags/louboutin" className="view-all-button">
          クリスチャン・ルブタンのバッグを見る
        </Link>        
        <div className="text-max-width">
          <h2>パロマ</h2>
          <p>ハンドバッグとしてもショルダーとしても使用でき季節問わずオールシーズン使っていただけるバッグです♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/21.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/22.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Christian Louboutin／パロマ・スモール／21 x22 x12cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/23.jpg" alt="" />
            <span className="text-center">Christian Louboutin／パロマ・ラージ／34 x30 x14cm</span>   
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/24.jpg" alt="" />
              <span className="text-center">Christian Louboutin／パロマ・スモール／21 x20 x10cm</span>   
          </figure>
        </div>        
        <div className="text-max-width">
          <h2>パロマクラッチ</h2>
          <p>メタルロゴとスタッズがおしゃれ♡ショルダーにもクラッチバッグにも使用できパーティースタイルにオススメです♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/25.jpg" alt="" />
          </figure>        
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/26.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Christian Louboutin／パロマクラッチ／23 x14 x4cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/27.jpg" alt="" />
            <span className="text-center">Christian Louboutin／パロマクラッチ／23 x14 x4cm</span>   
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/28.jpg" alt="" />
              <span className="text-center">Christian Louboutin／パロマクラッチ／23 x14 x5cm</span>   
          </figure>
        </div>                
        <div className="text-max-width">
          <h2>パッセージミニ</h2>
          <p>メタルハンドルのカーブは「ギャラリー・ヴェロ・ドダ」というアーケード街をイメージ。ルブタンのこだわりが表現された一品です♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/29.jpg" alt="" />
          </figure>            
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/30.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Christian Louboutin／パッセージミニ／20 x17 x13cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/31.jpg" alt="" />
            <span className="text-center">Christian Louboutin／パッセージミニ／20 x17 x10cm</span>   
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/32.jpg" alt="" />
              <span className="text-center">Christian Louboutin／パッセージミニ／20 x16 x12cm</span>   
          </figure>
        </div>
        <div className="text-max-width">
          <h2>トリルビ</h2>
          <p>3つのバッグが連結したようなデザイン。それぞれにファスナーが付いており機能性抜群！オーロラに輝くスタッズがエレガント♡</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/33.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/34.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Christian Louboutin／トリルビ／20 x15 x8cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/35.jpg" alt="" />
            <span className="text-center">Christian Louboutin／トリルビ／25 x18 x7cm</span>   
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/36.jpg" alt="" />
              <span className="text-center">Christian Louboutin／トリルビ／20 x15 x8cm</span>   
          </figure>
        </div>
        <div className="text-max-width">
          <h2>エロイーズ</h2>
          <p>女性らしいしなやかなフォルムが特徴♡アイコニックなデザインで収納力抜群！アクティブな女性にピッタリです♪</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/37.jpg" alt="" />
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/38.jpg" alt="" />
          </figure>
        </div>
        <span className="text-center">Christian Louboutin／エロイーズ／23 x23 x11cm</span>   
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/30/39.jpg" alt="" />
            <span className="text-center">Christian Louboutin／エロイーズ／22 x22 x11cm</span>   
          </figure>          
          <figure className="img-small">
              <StaticImage src="../../images/posts/30/40.jpg" alt="" />
              <span className="text-center">Christian Louboutin／エロイーズ／22 x21 x11cm</span>   
          </figure>
        </div>                                          
        <Link to="https://laxus.co/app/pc/bags/louboutin" className="view-all-button">
          クリスチャン・ルブタンのバッグを見る
        </Link>                
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post30

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 30}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
